export function simulateHeartRate(current: number, intensity: number): number {
  // Base variance based on intensity
  const baseVariance = Math.min(intensity * 2, 10);
  
  // Add some randomness to the variance
  const variance = baseVariance * (0.8 + Math.random() * 0.4);
  
  // Calculate change with weighted randomness
  const change = (Math.random() * variance * 2) - variance;
  
  // Add trend based on intensity
  const trend = intensity > 10 ? 0.5 : -0.2;
  
  // Calculate new heart rate
  const newRate = current + change + trend;
  
  // Ensure heart rate stays within realistic bounds
  return Math.max(60, Math.min(190, newRate));
}

export function calculateStrain(
  heartRate: number,
  maxHR: number = 190,
  duration: number
): number {
  // Calculate heart rate reserve (HRR)
  const restingHR = 60;
  const hrr = (heartRate - restingHR) / (maxHR - restingHR);
  
  // Calculate base strain
  const baseStrain = hrr * 10;
  
  // Add duration factor (increases strain over time)
  const durationFactor = Math.log10(duration / 60 + 1);
  
  // Calculate final strain
  const strain = baseStrain * (1 + durationFactor);
  
  // Cap strain at 21.0
  return Math.min(Math.max(0, strain), 21.0);
}